import { Building } from "../../../../types/building";
import { Coord } from "../../../../types/grid";
import { Unit } from "../../../../types/unit";

export function getUnitAtThisCell({ units, x, y }: Coord & { units: Unit[] }) {
  for (var i = 0; i < units.length; i++) {
    let currentUnitPos = units[i].position;
    if (currentUnitPos.x === x && currentUnitPos.y === y) {
      return units[i];
    }
  }

  return undefined;
}

export function getBuildingAtThisCell({
  buildings,
  x,
  y,
}: Coord & { buildings: Building[] }) {
  for (var i = 0; i < buildings.length; i++) {
    let currentUnitPos = buildings[i].position;
    if (currentUnitPos.x === x && currentUnitPos.y === y) {
      return buildings[i];
    }
  }

  return undefined;
}

export function getUnitIdx(units: Unit[], selectedUnit: Unit) {
  for (var i = 0; i < units.length; i++) {
    if (
      units[i].position.x === selectedUnit.position.x &&
      units[i].position.y === selectedUnit.position.y
    ) {
      return i;
    }
  }
}
